module.exports = __webpack_public_path__ + "img/Prime_logo_channel_m.85785711.svg";